module.exports = __webpack_public_path__ + "img/print-sxhpay.7d56a9b3.png";